import React from "react";
import { Mention } from "../types";
import { formatNeuralTime } from "../utils/routes";
import { CloseButton, MentionCard, MentionsPanel as StyledPanel, PanelHeading, PanelInner, MutedText } from "../styles";

type Props = { open: boolean; mentions: Mention[]; loading: boolean; error: string; onClose: () => void; onSelect: (mention: Mention) => void };

export const MentionPanel: React.FC<Props> = ({ open, mentions, loading, error, onClose, onSelect }) => (
  <StyledPanel $open={open} aria-label="읽지 않은 멘션">
    <PanelInner>
      <PanelHeading><h2>Unread mentions</h2><CloseButton type="button" aria-label="멘션 닫기" onClick={onClose}>×</CloseButton></PanelHeading>
      {loading && <MutedText>불러오는 중…</MutedText>}
      {error && <MutedText role="alert">{error}</MutedText>}
      {!loading && !error && !mentions.length && <MutedText>새로운 멘션이 없습니다.</MutedText>}
      {mentions.map((mention) => <MentionCard key={mention.id} type="button" onClick={() => onSelect(mention)}><strong>{mention.room.name} · {mention.sender.display_name}</strong><span>{mention.message.body_summary}</span><span>{formatNeuralTime(mention.created_at)}</span></MentionCard>)}
    </PanelInner>
  </StyledPanel>
);
